import React from "react";
import AboutUsRedesign from "../redesign/AboutUsRedesign";

const AboutUs = () => {
  return <AboutUsRedesign />;
};

export default AboutUs;
